document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper('.swiper-slider-custom', {
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: '.cfc-swiper-button-next',
      prevEl: '.cfc-swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  });
  const swiperNew = new Swiper('.swiper-review-slider', {
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
    },
    paginationClickable: true,
  });
  const swiperMobile = new Swiper('.featured-collection-mobile-s', {
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: '.fc-swiper-button-next',
      prevEl: '.fc-swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.5,
         spaceBetween: 15
      },
      768: {
        slidesPerView: 4,
         spaceBetween: 30
      }
    }
  });
})

// const swiper = new Swiper('.swiper-slider-collection', {
//   loop: true,
//   autoHeight: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   breakpoints: {
//     // when window width is >= 320px
//     320: {
//       slidesPerView: 1.5,
//       spaceBetween: 15,
//     },
//     // when window width is >= 640px
//     768: {
//       slidesPerView: 4,
//       spaceBetween: 30
//     }
//   }
// });

const multicolumnElements = document.querySelectorAll('.swiper-multicolumn');
if (multicolumnElements.length > 0) {
  const MulticolumnSwiper = new Swiper('.swiper-multicolumn', {
    slidesPerView: 1,
    spaceBetween: 40,
    breakpoints: {
      640: { slidesPerView: 2, spaceBetween: 40 },
      768: { slidesPerView: 3, spaceBetween: 40 },
      1024: { slidesPerView: 3, spaceBetween: 40 },
      1280: { slidesPerView: 4, spaceBetween: 40 },
    },
  });
  
  // Function to handle window resize
  const handleResize = () => {
    // Check if MulticolumnSwiper is defined
    if (MulticolumnSwiper && MulticolumnSwiper.update) {
      MulticolumnSwiper.update(); // Update Swiper instance on resize
    }
  };
  
  // Add event listener for window resize
  window.addEventListener('resize', handleResize);
  
  // Optionally, you can also handle the initial window size
  window.addEventListener('load', handleResize);
}


$(function() {
  $('.collection-main .collection-content .grid-product__title').matchHeight();
  $('.collection-main .collection-content .product-details-desc').matchHeight();
  $('.featured-collection-mobile-s .grid-product__meta').matchHeight();
   $('.search-template .grid-product__meta').matchHeight();
});

window.addEventListener("load", function () {
  document.querySelectorAll("[data-truncate]").forEach(function (element) {
    element.addEventListener("click", function (event) {
      if (!event.target.matches("a, a *")) {
        event.preventDefault();

        var shortElement = document.querySelector(".truncate__short");
        var longElement = document.querySelector(".truncate__long");

        if (shortElement.classList.contains("active")) {
          shortElement.classList.remove("active");
          longElement.classList.add("active");
        } else {
          shortElement.classList.add("active");
          longElement.classList.remove("active");
        }
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", (event) => {

  var modal = document.getElementById("product_popup-modal");
  // var btn = document.getElementById("myBtn");
  var closeBtn = document.querySelectorAll("#product_popup-modal .close");
  var openbody = document.body;
  var closebody = document.body;
  function openModal() {
    modal.style.display = "block";
    openbody.classList.add('overflow-hidden'); 
  }
  function closeModal() {
    modal.style.display = "none";
    document.body.classList.remove("unloading");
    closebody.classList.remove('overflow-hidden');
  }
  // btn.addEventListener("click", openModal);
  closeBtn.forEach(el => {
    el.addEventListener("click", closeModal);
  })
  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.key === "Esc") {
      closeModal();
    }
  });

  

  window.addDataToModalAndOpen = function(product, b2bPrice){

    modal.style.display = "block";
    openModal();
    let modalProductInjector = document.querySelector("#product_popup-modal .Product_content");
    // let productOptions = product.options_with_values.map(option => `<span>${option.name}: ${option.value}</span>`).join('<br>');
   console.log("modalProductInjector",modalProductInjector)
    let productOptions = product.options_with_values
    .filter(option => option.value !== "Default Title")
    .map(option => `<span>${option.name}: ${option.value}</span>`)
    .join('<br>');

    let ModalInnerData = `
      <div class="product_media">
        <img src='${ product.image }' height="300" width="300">
      </div>
      <div class="product_details">
        <div class="product_vendor">
          <span>${ product.vendor }</span>
        </div>
        <div class="product_title">
          <span>${ product.title }</span>
        </div>
        <div class="product_properties">
          ${ productOptions }
        </div>
        <div class="product-price grid-product__price">
        
       
        </div>
        <div class="modal-footer">
        <div class="close dogtra__primary-btn" id="continue_shopping">Continue Shopping</div>
        <a href="/cart" class="dogtra__secondary-btn">View Cart</a>
      </div>
      </div>
    `;
    modalProductInjector.innerHTML = ModalInnerData;

    
  var continue_shoping = document.getElementById("continue_shopping");
  continue_shoping.addEventListener("click", function (event) {
      closeModal();
  });

setTimeout(function() {
    var pid = product.product_id; 
   
    var gridItem = '';
    if(document.querySelectorAll('#CollectionAjaxContent .grid__item').length != 0){
       var gridItems = document.querySelectorAll('#CollectionAjaxContent .grid__item');
    }
    else {
         var gridItems = document.querySelectorAll('.custom-grid .grid__item');
      }
 
   
    if(gridItems)
  
    var gridItem = Array.from(gridItems).find(function(item) {
        var dataProductId = parseInt(item.getAttribute('data-product-id'));
        return dataProductId === parseInt(pid);
    });
    if (gridItem) {
        var tagPrices = gridItem.querySelector('.tag-prices');
        if(tagPrices){
        var discountPrice = tagPrices.getAttribute('data-b2bprice');
        var originalPrice = tagPrices.getAttribute('data-originalprice');
        if(discountPrice != '' && originalPrice != ''){
          setTimeout(function(){
             var productPriceDiv = document.querySelector('.product-price');
             while (productPriceDiv.firstChild) {
                productPriceDiv.removeChild(productPriceDiv.firstChild);
            }
            var discountPriceSpan = document.createElement('span');
            discountPriceSpan.textContent = discountPrice;
            discountPriceSpan.classList.add('grid-product__price--discounted');
            var originalPriceSpan = document.createElement('span');
            originalPriceSpan.textContent = originalPrice;
            originalPriceSpan.classList.add('grid-product__price--original');
            productPriceDiv.appendChild(discountPriceSpan);
            productPriceDiv.appendChild(originalPriceSpan);
          },300)
        }
        }
        else{
          var productPriceDiv = document.querySelector('.product-price');
            var gridProductPriceSpan = gridItem.querySelector('.grid-product__price');
            if (gridProductPriceSpan) {
                productPriceDiv.appendChild(gridProductPriceSpan);
            }
        }
    }
}, 500);

    
  }
  
  class MyCustomElement extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback(element) {
      this.addEventListener("click", this.removeLineItem.bind(this));
    }

    removeLineItem(){
      let cartItemRow = this.closest(".cart__item");
      cartItemRow.querySelector(".cart__item--qty input.js-qty__num").value = 0;
      let inputEl = cartItemRow.querySelector(".cart__item--qty input.js-qty__num");
      
      const changeEvent = new MouseEvent("change", {
        bubbles: true,
        cancelable: true,
        view: window
      });
      inputEl.dispatchEvent(changeEvent);    
    }
  }
  customElements.define("remove-line-item", MyCustomElement);
  
})


// document.addEventListener("DOMContentLoaded", function () {
//   // Create the back-to-top button with an SVG icon
//   var backToTopBtn = document.createElement("button");
//   backToTopBtn.classList.add("back-to-top-btn");
  
//   var svgIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
//   console.log(svgIcon);
//   svgIcon.setAttribute("width", "24");
//   svgIcon.setAttribute("height", "24");
//   svgIcon.setAttribute("viewBox", "0 0 24 24");
//   svgIcon.innerHTML = '<path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"/></svg>';

                          
//   backToTopBtn.appendChild(svgIcon);
//   document.body.appendChild(backToTopBtn);

//   // Show/hide the button based on the scroll position
//   window.addEventListener("scroll", function () {
//     if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
//       backToTopBtn.style.display = "block";
//     } else {
//       backToTopBtn.style.display = "none";
//     }
//   });

//   // Smoothly scroll to the top when the button is clicked
//   backToTopBtn.addEventListener("click", function () {
//     scrollToTop();
//   });
// });

// function scrollToTop() {
//   // Scroll to the top of the document with smooth behavior
//   window.scrollTo({
//     top: 0,
//     behavior: "smooth"
//   });
// }

document.addEventListener("DOMContentLoaded", function () {
  var backToTopBtn = document.querySelector(".back-to-top-btn");
  
  // Show/hide the button based on the scroll position
  window.addEventListener("scroll", function () {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      backToTopBtn.style.display = "block";
    } else {
      backToTopBtn.style.display = "none";
    }
  });

  backToTopBtn.addEventListener("click", function () {
    scrollToTop();
  });
});

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}


if($('.collection-main').length) {
  const checkWindowSize = () => {
    const filterDrawer = document.getElementById('FilterDrawer');
  
    // Check if the element exists before accessing its properties
    if (filterDrawer) {
      const windowWidth = window.innerWidth;
  
      if (windowWidth >= 1000) {
        filterDrawer.classList.add('drawer--is-open');
        filterDrawer.style.display = 'block';
        filterDrawer.style.position = 'relative';
      } else {
        filterDrawer.classList.remove('drawer--is-open');
        // filterDrawer.style.display = 'none';
        filterDrawer.style.position = 'fixed';
      }
    } 
  };
  window.addEventListener('load', checkWindowSize);
  window.addEventListener('resize', checkWindowSize);
}

// Redirect to previous


function setPreviousPageCookie() {
  // Get the current URL
  var currentUrl = window.location.href;

  // Set the previous page URL in a cookie named 'previousPage'
  document.cookie = 'previousPage=' + encodeURIComponent(currentUrl) + '; path=/'; // Added path=/
}

function getCookie(name) {
  var cookieParts = document.cookie.split(';');
  for (var i = 0; i < cookieParts.length; i++) {
    var cookiePart = cookieParts[i].trim();
    if (cookiePart.indexOf(name + '=') === 0) {
      return decodeURIComponent(cookiePart.substring(name.length + 1));
    }
  }
  return null;
}

// Attach click event listener to the #account element
var accountButton = document.getElementById('account');

if (accountButton) {
  accountButton.addEventListener('click', setPreviousPageCookie);
}

document.addEventListener('DOMContentLoaded', function() {
  var returnUrlInput = document.querySelector('input[name="return_url"]');
  
  if (returnUrlInput) {
    returnUrlInput.value = getCookie('previousPage');
  }
});

$('.megamenu__columns-content .megamenu__columns:first-child').addClass('active');
$('.custom-megamenu .megamenu__cols .list-wrapper a').click( function() {
    $('.megamenu__columns-content .megamenu__columns:first-child').removeClass('active');
	var tabID = $(this).attr('data-sub');
   console.log(tabID);
    $(this).addClass('active').siblings().removeClass('active');
	$('div#tab-'+tabID).addClass('active').siblings().removeClass('active');	
});

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - document.querySelector('#StickyHeaderWrap').offsetHeight
    }, 1500);
});

window.addEventListener("scroll", function () {
  var announcementBar = document.querySelector(".announcement");
  var siteHeader = document.getElementById("SiteHeader");
  
   if (window.scrollY > 250 && siteHeader.getAttribute('data-sticky') === 'true') {
    announcementBar.classList.add("announcement--sticky");
    var announcementHeight = announcementBar.offsetHeight;
    siteHeader.style.top = announcementHeight + "px";
    console.log("Height of announcement bar: " + announcementHeight + "px");
    setTimeout(function () {
      announcementBar.classList.add("announcement-sticky--opening");
    }, 100);
  } else {
    announcementBar.classList.remove("announcement--sticky");
    siteHeader.style.top = "0";
    announcementBar.classList.remove("announcement-sticky--opening");
  }
});